export default __webpack_public_path__ + "media/images/SkypeBlue_16x16-b1b219f4019d54583da0ea8ed86db9d3.png";